module.exports = __webpack_public_path__ + "img/rekom_logo_clean.2070d0d3.svg";